// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__qy1dB","header":"MessagesList_header__dCGNj","chat":"MessagesList_chat__k206q"};